import { useEffect } from "react";

const useScrollToSummary = ({ scrollStateTarget, containerId, cb }) => {
  useEffect(() => {
    if (scrollStateTarget === containerId) {
      cb();
    }
  }, [scrollStateTarget, cb, containerId]);
};

export default useScrollToSummary;
